export enum Permission {
    TrainingJob = 'isTrainingJob',
    MpJob = 'isMpJob',
    Staff = 'isStaff',
    Timesheet = 'isTimesheet',
    MyDocs = 'isMyDocs',
    Inductions = 'isInductions',
    Accident = 'isAccident',
    Asset = 'isAsset',
    LabourJob = 'isLabourjob',
    Client = 'isClient',
}